import React, { useState } from 'react'
import DocumentMeta from 'core/components/DocumentMeta'
import DateCell from 'core/components/listTable/cells/DateCell'
import Badge from 'core/elements/badge'
import Button from 'core/elements/button/Button'
import Grid from 'core/elements/grid'
import { GridViewColumn } from 'core/elements/grid/Grid'
import getGridDialogButton from 'core/elements/grid/helpers/getGridDialogButton'
import { GridRowMenuItemSpec } from 'core/elements/grid/hooks/useGridRowMenu'
import { GridBatchActionSpec } from 'core/elements/grid/hooks/useGridSelectableRows'
import AlertDetailsDialog from './AlertDetailsDialog'

const data = [
  {
    id: '1',
    timestamp: '2025-07-29T03:12:45Z',
    severity: 'Critical',
    title: 'Load Balancer Capacity Exceeded',
    description: 'Load balancer capacity is low',
  },
  {
    id: '2',
    timestamp: '2025-07-29T11:47:30Z',
    severity: 'Warning',
    title: 'Reserved IP Addresses',
    description: 'Reserved IP addresses are low',
  },
  {
    id: '3',
    timestamp: '2025-07-29T19:26:08Z',
    severity: 'Info',
    title: 'New VM Discovered',
    description: 'New VM Discovered',
  },
]

// type ModelDataKey = DataKeys.OpenStackAlerts
type SelectorModel = any

const AlertSeverityCell = ({ value }) => {
  let badgeVariant
  switch (value) {
    case 'Critical':
      badgeVariant = 'error'
      break
    case 'Warning':
      badgeVariant = 'warning'
      break
    default:
      badgeVariant = 'secondary'
  }
  return <Badge variant={badgeVariant} text={value} />
}

const columns: GridViewColumn<SelectorModel>[] = [
  {
    key: 'timestamp',
    label: 'Date',
    CellComponent: DateCell,
  },
  {
    key: 'severity',
    label: 'Severity',
    CellComponent: AlertSeverityCell,
  },
  {
    key: 'title',
    label: 'Title',
  },
  {
    key: 'description',
    label: 'Description',
  },
]

const batchActions: GridBatchActionSpec<any>[] = [
  {
    label: 'Delete',
    icon: 'trash-alt',
  },
]

export default function AlertsListPage() {
  const [showAlertDetailsDialog, setShowAlertDetailsDialog] = useState(false)
  const [selectedAlert, setSelectedAlert] = useState(null)

  const rowMenuItems: GridRowMenuItemSpec<any>[] = [
    {
      cond: (alert) => alert.severity !== 'Info',
      disabledTooltip: 'Only non-info alerts can be resolved',
      label: 'Resolve',
      icon: 'wrench',
      handleClick: (alert) => {
        setSelectedAlert(alert)
        setShowAlertDetailsDialog(true)
      },
      refreshAfterSuccess: true,
      hideIfDisabled: true,
    },
  ]

  return (
    <div>
      <DocumentMeta title="Alerts" breadcrumbs />
      {showAlertDetailsDialog && (
        <AlertDetailsDialog
          alert={selectedAlert}
          onClose={() => setShowAlertDetailsDialog(false)}
        />
      )}
      <Grid
        uniqueIdentifier="id"
        label="Alerts"
        columns={columns}
        data={data}
        orderBy="timestamp"
        orderDirection="desc"
        emptyContent="No alerts found"
        rowMenuItems={rowMenuItems}
        batchActions={batchActions}
        multiSelection
      />
    </div>
  )
}
